import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const AUTO_LIST_FIELD_CLASS_NAME = 'AutoListField';
export const AUTO_LIST_FIELD_CLASS_SLOTS = ['root'] as const;

export type AutoListFieldClassSlot =
	(typeof AUTO_LIST_FIELD_CLASS_SLOTS)[number];

export interface AutoListFieldClasses {
	root: string;

	labelHidden: string;
}

export type AutoListFieldClassKey = keyof AutoListFieldClasses;

export const getAutoListFieldUtilityClass = (slot: string) =>
	generateUtilityClass(AUTO_LIST_FIELD_CLASS_NAME, slot);

export const autoListFieldClasses = generateUtilityClasses<
	keyof AutoListFieldClasses
>(AUTO_LIST_FIELD_CLASS_NAME, ['root', 'labelHidden']);

export default autoListFieldClasses;
